module.exports = __webpack_public_path__ + "img/lucky-promotions.13a80c03.png";